import './i18next';
import moment from 'moment';
import 'moment-duration-format';
import 'moment/locale/ar';

/// ///////////////////////////

moment.locale('ar');

/// /////////////////////////

window.env = process.env.NODE_ENV === 'production' ? window.serverData : process.env;

/// //////////////
